const Education = [
  {
    designation: "B.Tech (Computer Science)",
    name: "HMR Institute of Technology and Management",
    duration: "2016 - 2020",
    info: [
      "Successfully completed four-year full-time course in Computer Science Engineering.",
      "Studied about design, implementation as well as management of computer software and hardware.",
      // "Percentage: 78.1%",
      "CGPA: 8.5",
    ],
  },
  {
    designation: "12th (Senior Secondary)",
    name: "St. Mary's School,New Delhi,India",
    duration: "2015 - 2016",
    info: [
      "Successfully completed Senior Secondary Education.",
      "Non-Medical(PCM) stream",
      // "Percentage: 81.4%",
      "CGPA: 8.6",
    ],
  },
  {
    designation: "10th (Secondary)",
    name: "St. Mary's School,New Delhi,India",
    duration: "2015 - 2016",
    info: [
      "Successfully completed Secondary Education.",
      "Science stream",
      "CGPA: 8.8",
    ],
  },
];

export { Education };
